module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av57-4e2d0320e3d8698c77b29f6f393c99ff.jpg";